require(".../../owl.carousel");

exports.init = function ($) {
  //  console.log('Carousel Set up');
  let owlElem = $('.owl-carousel');

  owlElem.owlCarousel({
    loop: $('.owl-carousel img').length > 3 ? true : false,
    center: $('.owl-carousel img').length > 3 ? true : false,
    margin: 15,
    dots: false,
    nav: false,
    mouseDrag: false,
    touchDrag: true,
    navText: [
      '',''
    ],
    responsive: {
      0: {
        center: true,
        items: 2,
        loop: true,
      },
      768: {
        items: 2,
        nav: true
      },
      1024: {
        items: 3,
        nav: true
      },
      1300: {
        items: 4,
        nav: true
      },
    }
  });

};